module.exports = __webpack_public_path__ + "static/media/9.db685e01.jpg";